export default __webpack_public_path__ + "static/media/ic_estonia.62814ea0.svg";